import React from "react";

import "../Cell.scss";

import Skeleton from "react-loading-skeleton";

const ImageCell = ({ value, urlPrefix }: ImageCellProps) => {
  return (
    <div key={`cell-image-${value}`} className="image">
      {value && value !== "null" ? (
        <img src={urlPrefix ? `${urlPrefix}${value}` : value} />
      ) : (
        <Skeleton height={75} />
      )}
    </div>
  );
};

export default ImageCell;

interface ImageCellProps {
  value: string;
  urlPrefix: string | undefined;
}
